<template>
  <v-card tile flat class="mt-4">
    <v-card-text class="px-0">
      <v-form autocomplete="off">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
            <v-select
              dense
              :disabled="current_user.lingkup.tingkat != 1"
              outlined
              placeholder="Isikan Propinsi"
              :items="itemProvinsis"
              v-model="filtered.propinsi_id"
              item-value="id"
              item-text="keterangan"
              @change="getKota(filtered.propinsi_id)"
              label="Propinsi"
              data-vv-name="provinsi"
              data-vv-as="Propinsi"
              v-validate="'required'"
              :error-messages="errors.collect('form.provinsi')"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
            <v-select
              clearable
              dense
              :disabled="statusBlockKota"
              outlined
              placeholder="Isikan Kota/Kabupaten"
              :items="itemKotas"
              v-model="filtered.kota_id"
              @change="getKecamatan(filtered.kota_id)"
              item-value="id"
              item-text="keterangan"
              label="Kota/Kabupaten"
              data-vv-name="kota"
              data-vv-as="Kota/Kabupaten"
              v-validate="'required'"
              :error-messages="errors.collect('form.kota')"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
            <v-select
              clearable
              dense
              outlined
              :disabled="statusBlockKecamatan"
              placeholder="Isikan Kecamatan"
              :items="itemKecamatans"
              v-model="filtered.kecamatan_id"
              item-value="id"
              item-text="keterangan"
              @change="getKelurahan(filtered.kecamatan_id)"
              label="Kecamatan"
              data-vv-name="kecamatan"
              data-vv-as="Kecamatan"
              v-validate="'required'"
              :error-messages="errors.collect('form.kecamatan')"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
            <v-select
              clearable
              dense
              outlined
              placeholder="Isikan Kelurahan"
              :items="itemKelurahans"
              v-model="filtered.kelurahan_id"
              item-value="id"
              item-text="keterangan"
              @change="$emit('filter', filtered)"
              label="Kelurahan"
              data-vv-name="kelurahan"
              data-vv-as="Kelurahan"
              v-validate="'required'"
              :error-messages="errors.collect('form.keurahan')"
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="py-4"></v-divider>
        <div class="grey lighten-3 px-4">
          <v-row class="pt-4">
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                placeholder="Pilih Status KTA"
                :items="itemStatusKTA"
                v-model="filtered.status_kta"
                item-value="id"
                item-text="keterangan"
                label="Status KTA"
                data-vv-name="status_kta"
                data-vv-as="Status KTA"
                v-validate="'required'"
                :error-messages="errors.collect('form.status_kta')"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                :items="[{ nama: 'Tanggal ditambahkan terbaru', id: 1 }, { nama: 'Tanggal ditambahkan terlama', id: 2 }]"
                label="Tanggal"
                name="Tanggal"
                placeholder="Tanggal"
                v-model="filtered.tanggal"
                hint="Urutkan berdasarkan tanggal"
                data-vv-name="bobot"
                data-vv-as="Tanggal"
                item-text="nama"
                item-value="id"
              ></v-select
            ></v-col>
<!--            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">-->
<!--              <v-select-->
<!--                clearable-->
<!--                dense-->
<!--                outlined-->
<!--                :items="[{ nama: 'SIPOL', id: 1 }, { nama: 'Non Sipol', id: 0 }]"-->
<!--                label="Status SIPOL"-->
<!--                name="Status SIPOL"-->
<!--                placeholder="Status SIPOL"-->
<!--                v-model="filtered.sipol"-->
<!--                hint="Status SIPOL"-->
<!--                data-vv-name="sipol"-->
<!--                data-vv-as="SIPOL"-->
<!--                item-text="nama"-->
<!--                item-value="id"-->
<!--              ></v-select-->
<!--            ></v-col>-->
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                :items="itemKategori"
                label="Kategori"
                name="Kategori"
                placeholder="Kategori"
                v-model="filtered.kategori"
                hint="Kategori"
                data-vv-name="kategori"
                data-vv-as="Kategori"
                item-text="nama"
                item-value="id"
              ></v-select
            ></v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                placeholder="Status Pendaftaran"
                :items="[{ id: 1, keterangan: 'PBB' }, { id: 0, keterangan: 'Tidak Terdaftar' }, { id: 2, keterangan: 'Ganda' }, { id: 3, keterangan: 'Partai Lainnya' }]"
                v-model="filtered.is_daftar"
                item-value="id"
                item-text="keterangan"
                label="Status Pendaftaran"
                data-vv-name="pendaftaran"
                data-vv-as="Status Pendaftaran"
                v-validate="'required'"
                :error-messages="errors.collect('form.pendaftaran')"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                placeholder="Status Sampling"
                :items="[{ id: 1, keterangan: 'Sampling' }, { id: 0, keterangan: 'Non Sampling' }]"
                v-model="filtered.is_sampling"
                item-value="id"
                item-text="keterangan"
                label="Status Sampling"
                data-vv-name="sampling"
                data-vv-as="Status Sampling"
                v-validate="'required'"
                :error-messages="errors.collect('form.sampling')"
              ></v-select>
            </v-col>
<!--            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">-->
<!--              <v-select-->
<!--                clearable-->
<!--                dense-->
<!--                outlined-->
<!--                placeholder="Status DPB"-->
<!--                :items="[{ id: 1, keterangan: 'Masuk DPB' }, { id: 0, keterangan: 'Belum dicek' }, { id: 9, keterangan: 'Belum Masuk DPB' }]"-->
<!--                v-model="filtered.validasi_lindungi_hak_mu"-->
<!--                item-value="id"-->
<!--                item-text="keterangan"-->
<!--                label="Status DPB"-->
<!--                data-vv-name="validasi"-->
<!--                data-vv-as="Status DPB"-->
<!--                v-validate="'required'"-->
<!--                :error-messages="errors.collect('form.validasi')"-->
<!--              ></v-select>-->
<!--            </v-col>-->
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                :items="itemcetakkta"
                label="Cetak KTA"
                name="Cetak KTA"
                placeholder="Status Cetak KTA"
                v-model="filtered.is_cetak"
                hint="Cetak KTA"
                data-vv-name="jumlah_terdaftar"
                data-vv-as="Cetak KTA"
                item-text="nama"
                item-value="id"
              ></v-select
            ></v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                :items="[{ id: 1, nama: 'Ya' }, { id: 0, nama: 'Tidak' }]"
                label="Simulasi Verfak"
                name="Simulasi Verfak"
                placeholder="Status Warga"
                v-model="filtered.is_sampling_kpu"
                hint="Simulasi Verfak"
                data-vv-name="data_warga"
                data-vv-as="Data Warga"
                item-text="nama"
                item-value="id"
              ></v-select
            ></v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                :items="[{ id: 1, nama: 'MS' }, { id: 0, nama: 'BMS' }]"
                label="MS/BMS Verfak"
                name="MS/BMS Verfak"
                placeholder="Status Warga"
                v-model="filtered.is_ms_verfak"
                hint="MS/BMS Verfak"
                data-vv-name="data_warga"
                data-vv-as="Data Warga"
                item-text="nama"
                item-value="id"
              ></v-select
              ></v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                :items="[{ id: 1, nama: 'Daftar' }, { id: 0, nama: 'Tidak Daftar' }]"
                label="Daftar/Tidak Daftar Verfak"
                name="Daftar/Tidak Daftar Verfak"
                placeholder="Status Warga"
                v-model="filtered.is_daftar_verfak"
                hint="Daftar/Tidak Daftar Verfak"
                data-vv-name="data_warga"
                data-vv-as="Data Warga"
                item-text="nama"
                item-value="id"
              ></v-select
              ></v-col>
<!--            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">-->
<!--              <v-select-->
<!--                clearable-->
<!--                dense-->
<!--                outlined-->
<!--                :items="[{ id: 1, nama: 'Ya' }, { id: 0, nama: 'Tidak' }]"-->
<!--                label="Tindak Lanjut Perbaikan"-->
<!--                name="Tindak Lanjut Perbaikan"-->
<!--                placeholder="Tindak Lanjut Perbaikan"-->
<!--                v-model="filtered.is_bermasalah_2"-->
<!--                hint="Tindak Lanjut Perbaikan"-->
<!--                data-vv-name="perbaikan"-->
<!--                data-vv-as="Data Perbaikan"-->
<!--                item-text="nama"-->
<!--                item-value="id"-->
<!--              ></v-select-->
<!--            ></v-col>-->
<!--            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">-->
<!--              <v-select-->
<!--                clearable-->
<!--                dense-->
<!--                outlined-->
<!--                :items="itemUnggahSurats"-->
<!--                label="Unggah Surat"-->
<!--                name="Unggah Surat"-->
<!--                placeholder="Unggah Surat"-->
<!--                v-model="filtered.is_unggahsurat"-->
<!--                hint="Unggah Surat"-->
<!--                data-vv-name="unggah_surat"-->
<!--                data-vv-as="Unggah Surat"-->
<!--                item-text="nama"-->
<!--                item-value="id"-->
<!--              ></v-select-->
<!--            ></v-col>-->
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                :items="itemLama"
                label="Sipol Perbaikan"
                name="Sipol Perbaikan"
                placeholder="Sipol Perbaikan"
                v-model="filtered.is_lama"
                hint="Sipol Perbaikan"
                data-vv-name="is_lama"
                data-vv-as="Sipol Perbaikan"
                item-text="nama"
                item-value="id"
              ></v-select
            ></v-col>

            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                :items="[{ id: 1, nama: 'MS' }, { id: 0, nama: 'TMS' }]"
                label="MS/TMS Vermin"
                name="MS/TMS Vermin"
                placeholder="Status Warga"
                v-model="filtered.is_vermin"
                hint="MS/TMS Vermin"
                data-vv-name="data_warga"
                data-vv-as="Data Warga"
                item-text="nama"
                item-value="id"
              ></v-select
              ></v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                placeholder="Sample Verfak Perbaikan"
                :items="[{ id: 1, keterangan: 'Ya' }, { id: 0, keterangan: 'Tidak' }]"
                v-model="filtered.is_sample_verfak_perbaikan"
                item-value="id"
                item-text="keterangan"
                label="Sample Verfak Perbaikan"
                data-vv-name="Sample Verfak Perbaikan"
                data-vv-as="Sample Verfak Perbaikan"
                v-validate="'required'"
                :error-messages="errors.collect('form.sampling')"
              ></v-select>
            </v-col>


            <v-col cols="12" sm="6" md="6" lg="3" class="py-0">
              <v-select
                clearable
                dense
                outlined
                placeholder="Hapus Sipol"
                :items="[{ id: 1, keterangan: 'Ya' }, { id: 0, keterangan: 'Tidak' }]"
                v-model="filtered.is_hapus_sipol"
                item-value="id"
                item-text="keterangan"
                label="Hapus Sipol"
                data-vv-name="Hapus Sipol"
                data-vv-as="Hapus Sipol"
                v-validate="'required'"
                :error-messages="errors.collect('form.sampling')"
              ></v-select>
            </v-col>

            <v-col cols="12" class="pt-0 mt-0">
              <m-button dark color="primary" small depressed textButton="Filter" action="toAction" @toAction="$emit('filter', filtered)"></m-button
            ></v-col>
          </v-row>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    masters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: true,
      filtered: {
        propinsi_id: null,
        kota_id: null,
        kecamatan_id: null,
        kelurahan_id: null
      },
      itemPendaftars: [
        {
          id: 0,
          nama: "Belum Dicek"
        },
        {
          id: 1,
          nama: "Sekali"
        },
        {
          id: 2,
          nama: "lebih dari Sekali"
        }
      ],
      itemUnggahSurats: [
        {
          id: 1,
          nama: "Sudah"
        },
        {
          id: 0,
          nama: "Belum"
        }
      ],
      itemLama: [
        {
          id: 0,
          nama: "Ya"
        },
        {
          id: 1,
          nama: "Tidak"
        }
      ],
      itemcetakkta: [
        {
          id: 1,
          nama: "Ya"
        },
        {
          id: 0,
          nama: "Tidak"
        }
      ],
      itemKategori: [
        {
          id: 1,
          nama: "Anggota"
        },
        {
          id: 2,
          nama: "Ranting"
        },
        {
          id: 3,
          nama: "PAC"
        },
        {
          id: 4,
          nama: "DPC"
        },
        {
          id: 5,
          nama: "DPW"
        },
        {
          id: 6,
          nama: "DPP"
        }
      ],
      itemProvinsis: [],
      itemKotas: [],
      itemKecamatans: [],
      itemKelurahans: [],
      itemKategories: [],
      itemPekerjaans: [],
      idBlockKota: [3, 4],
      idBlockKecamatan: [4],
      statusBlockKota: false,
      statusBlockKecamatan: false,
      itemStatusKTA: [
        {
          id: 1,
          keterangan: "Belum Punya KTA"
        },
        {
          id: 2,
          keterangan: "Sudah Punya KTA"
        },
        {
          id: 3,
          keterangan: "Dalam Proses"
        }
      ]
    };
  },
  mounted() {
    this.rend = this.rend + 1;

    this.statusBlockKota = this.idBlockKota.includes(this.current_user.lingkup.tingkat) ? true : false;
    this.statusBlockKecamatan = this.idBlockKecamatan.includes(this.current_user.lingkup.tingkat) ? true : false;

    this.getProvinsi();
  },
  methods: {
    getProvinsi() {
      return this.$store
        .dispatch("warga/getProvinsi", {
          params: {}
        })
        .then(res => {
          this.itemProvinsis = res;
          if (!this.edit && this.current_user.lingkup.tingkat == 3) {
            this.filtered.propinsi_id = this.current_user.lingkup.propinsi_id;
            this.getKota(this.filtered.propinsi_id);
          } else if (!this.edit && this.current_user.lingkup.tingkat == 4) {
            this.filtered.propinsi_id = this.current_user.lingkup.propinsi_id;
            this.getKota(this.filtered.propinsi_id);
          } else if (!this.edit && this.current_user.lingkup.tingkat == 2) {
            this.filtered.propinsi_id = this.current_user.lingkup.id;
            this.getKota(this.filtered.propinsi_id);
          }
        })
        .catch(e => e);
    },
    getKota(id) {
      if (this.filtered.propinsi_id) {
        this.$emit("filter", this.filtered);
        return this.$store
          .dispatch("warga/getKota", {
            id: id,
            params: {}
          })
          .then(res => {
            this.itemKotas = res;
            if (!this.edit && this.current_user.lingkup.tingkat == 3) {
              this.filtered.kota_id = this.current_user.lingkup.id;
              this.getKecamatan(this.filtered.kota_id);
            } else if (!this.edit && this.current_user.lingkup.tingkat == 4) {
              this.filtered.kota_id = this.current_user.lingkup.kota_id;
              this.getKecamatan(this.filtered.kota_id);
            }
          })
          .catch(e => e);
      } else {
        this.filtered.kota_id = null;
        this.filtered.kecamatan_id = null;
        this.filtered.kelurahan_id = null;
        var filteredKota = { propinsi_id: this.filtered.propinsi_id, kota_id: null, kecamatan_id: null, kelurahan_id: null };
        this.$emit("filter", filteredKota);
      }
    },
    getKecamatan(id) {
      if (this.filtered.kota_id) {
        this.$emit("filter", this.filtered);
        return this.$store
          .dispatch("warga/getKecamatan", {
            id: id,
            params: {}
          })
          .then(res => {
            this.itemKecamatans = res;
            if (!this.edit && this.current_user.lingkup.tingkat == 4) {
              this.filtered.kecamatan_id = this.current_user.lingkup.id;
              this.getKelurahan(this.filtered.kecamatan_id);
            }
          })
          .catch(e => e);
      } else {
        this.filtered.kecamatan_id = null;
        this.filtered.kelurahan_id = null;
        var filteredKecamatan = { propinsi_id: this.filtered.propinsi_id, kota_id: this.filtered.kota_id, kecamatan_id: null, kelurahan_id: null };
        this.$emit("filter", filteredKecamatan);
      }
    },
    getKelurahan(id) {
      if (this.filtered.kecamatan_id) {
        this.$emit("filter", this.filtered);
        return this.$store
          .dispatch("warga/getKelurahan", {
            id: id,
            params: {}
          })
          .then(res => {
            this.itemKelurahans = res;
          })
          .catch(e => e);
      } else {
        this.filtered.kecamatan_id = null;
        this.filtered.kelurahan_id = null;
        var filteredKelurahan = { propinsi_id: this.filtered.propinsi_id, kota_id: this.filtered.kota_id, kecamatan_id: this.filtered.kecamatan_id, kelurahan_id: null };
        this.$emit("filter", filteredKelurahan);
      }
    }
  },
  watch: {
    "warga.propinsi_id": function(n) {
      this.getKota(n);
    },
    "warga.kota_id": function(m) {
      this.getKecamatan(m);
    },
    "warga.kecamatan_id": function(o) {
      this.getKelurahan(o);
    },
    "warga.kelurahan_id": function() {
      this.$emit("filter", this.filtered);
    }
  }
};
</script>
